import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { reportsPath } from 'shared/routes/voucher';
import { modelMap } from 'shared/utils';
import { VOUCHER_TYPES } from 'shared/constants';
import { getGroupedVoucherReport } from 'shared/api/vouchers';
import DataTable from 'shared/components/table/DataTable';
import { FilterRedirect } from 'shared/hoc/withFilters';
import dateFilters from './helpers';

const orderMap = {
  manager: 'property_manager_name',
  complex: 'property_complex_name',
  property: 'property_name',
};

/**
 * @param {Object} props
 * @param {string} props.grouping
 * @param {string} props.filterKey
 * @param {string} props.savedFilters
 * @param {string} props.path
 */
// A report on redeemed vouchers grouped by manager/complex/property.
export default function GroupedReport({
  grouping, filterKey, savedFilters, path,
}) {
  const { search } = useLocation();
  const nameColumns = [grouping, ...modelMap[grouping].parents];

  const columns = [
    ...nameColumns.map((model) => ({
      name: modelMap[model].title,
      orderBy: orderMap[model],
      formatter: (row) => {
        const url = new URLSearchParams(search);
        const { idKey, nameKey } = modelMap[model];
        const route = `${reportsPath}/${model}/${row[idKey]}`;
        let newSearch;
        if (url.get('all_time') === 'true') {
          newSearch = '?all_time=true';
        } else {
          const startDate = url.has('start_date') ? `start_date=${url.get('start_date')}` : '';
          const endDate = startDate && url.has('end_date') ? `&end_date=${url.get('end_date')}` : '';
          newSearch = `?${startDate}${endDate}`;
        }
        return (
          <Link to={`${route}${newSearch}`}>
            {row[nameKey]}
          </Link>
        );
      },
    })),
    {
      name: VOUCHER_TYPES.free.label,
      jsonKey: 'free',
      orderBy: '4',
    },
    {
      name: VOUCHER_TYPES.billable.label,
      jsonKey: 'billable',
      orderBy: '5',
    },
    {
      name: 'Bill',
      jsonKey: 'bill',
      orderBy: '6',
    },
  ];

  const { title } = modelMap[grouping];

  const searchRequest = useCallback(
    (searchStr, accept) => getGroupedVoucherReport(searchStr, accept, grouping),
    [grouping],
  );

  const result = FilterRedirect(path, savedFilters);
  if (result) {
    return result;
  }

  return (
    <DataTable
      tableName={`Redeemed Vouchers by ${title}`}
      searchRequest={searchRequest}
      rowId={modelMap[grouping].idKey}
      columns={columns}
      filters={dateFilters}
      filterKey={filterKey}
      className="table-height-large"
    />
  );
}
